import React, { useState, useEffect } from 'react';
import { Dropdown, MenuItem, FormController, FormLabel, } from '@one-thd/sui-atomic-components';
import { ascendingOptions, defaultOrderByOptions, defaultSelectedOrderByOption, orderByOptionsMap, sortByValues, } from '../../models/b2b/add-manage-users';
export var UserSortOrder = function (_a) {
    var currentSortByOption = _a.currentSortByOption, onChange = _a.onChange;
    var _b = useState(defaultSelectedOrderByOption), selectedOrderOption = _b[0], setSelectedOrderOption = _b[1];
    var _c = useState(defaultOrderByOptions), currentOrderByOptions = _c[0], setCurrentOrderOptions = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var checkIfAscending = function (value) {
        var isAscending = ascendingOptions.indexOf(value) !== -1;
        return isAscending;
    };
    var handleSortChange = function (event) {
        var value = (event === null || event === void 0 ? void 0 : event.target).value;
        var orderOptions = orderByOptionsMap[value];
        var firstOrderOption = orderOptions[0];
        var isAscending = checkIfAscending(firstOrderOption);
        setCurrentOrderOptions(orderOptions);
        setSelectedOrderOption(firstOrderOption);
        onChange(value, isAscending);
    };
    var handleOrderChange = function (event) {
        var value = (event === null || event === void 0 ? void 0 : event.target).value;
        var isAscending = checkIfAscending(value);
        setSelectedOrderOption(value);
        onChange(currentSortByOption, isAscending);
    };
    useEffect(function () {
        if (isOpen) {
            /**
              The Dropdown component, when opened and `Date Added` is already selected, has
              two elements with the same "default-sort-option". We need to select the
              correct element to display only "Date Added (Default)" in the dropdown.
             */
            var index = currentSortByOption === 'Date Added' ? 1 : 0;
            var defaultOption = document.getElementsByClassName('default-sort-option')[index];
            if (defaultOption)
                defaultOption.innerHTML += ' (default)';
        }
    }, [isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-y-4 md:sui-grid md:sui-grid-cols-6 md:sui-gap-x-6 lg:sui-grid lg:sui-grid-cols-6 xl:sui-gap-x-8 lg:sui-gap-y-4 2xl:sui-grid-cols-5" },
            React.createElement("div", { className: "sui-col-span-3 md:sui-col-span-3 2xl:sui-col-start-2 2xl:sui-col-span-2" },
                React.createElement(FormController, { fullWidth: true },
                    React.createElement(FormLabel, { htmlFor: "sort-dropdown" }, "Sort By"),
                    React.createElement(Dropdown, { maxItems: 5, id: "sort-dropdown", "data-testid": "sort-dropdown", value: currentSortByOption, onChange: handleSortChange, onOpen: function () { return setIsOpen(true); }, onClose: function () { return setIsOpen(false); } }, sortByValues === null || sortByValues === void 0 ? void 0 : sortByValues.map(function (sortBy, index) { return (React.createElement(MenuItem, { key: sortBy, value: sortBy },
                        React.createElement("span", { className: index === 0 ? 'default-sort-option' : '' }, sortBy))); })))),
            React.createElement("div", { className: "sui-col-span-3 md:sui-col-span-3 2xl:sui-col-start-4 2xl:sui-col-span-2" },
                React.createElement(FormController, { fullWidth: true },
                    React.createElement(FormLabel, { htmlFor: "order-dropdown" }, "Sort Order"),
                    React.createElement(Dropdown, { maxItems: 2, id: "order-dropdown", "data-testid": "order-dropdown", value: selectedOrderOption, onChange: handleOrderChange }, currentOrderByOptions === null || currentOrderByOptions === void 0 ? void 0 : currentOrderByOptions.map(function (option) { return (React.createElement(MenuItem, { key: option, value: option }, option)); })))))));
};
